import moment, { Moment } from 'moment';
import 'react-dates/constants';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { SingleDatePicker } from 'react-dates';
import { BloodSample } from '../PatientBloodSamples';
import { useCallback, useEffect, useState } from 'react';
import { Row } from '../../../../../components/common/table/Row/Row';
import { Cell } from '../../../../../components/common/table/Cell/Cell';
import { convertDate, convertTime } from '../../../../../components/common/convertDateTime/convertDateTime';
import './react_dates_overrides.scss';
import './SampleHistoryRow.scss';
import { warning } from '../../../../../shared/styles/variables';
import { TextInput } from '../../../../../components/TextInput/TextInput';
import '../../../../../components/TextInput/TextInput.scss';

export interface SampleHistoryRowProps {
  sample: BloodSample;
  index: number;
  patientId?: string;
  updateApiData: any;
  token: string | null;
}

export const SampleHistoryRow = ({ sample, index }: SampleHistoryRowProps) => {
  const [status] = useState('');
  const [tempDrawDate, setTempDrawDate] = useState<any>(null);
  const [drawDate] = useState<string>(convertDate(sample.body.draw_date_time_utc));
  const [tempDrawTime, setTempDrawTime] = useState<any>(null);
  const [drawTime] = useState<string>(convertTime(sample.body.draw_date_time_utc));
  const [sampleId] = useState<string>(sample.body.encrypt_vial_id);
  const [bloodBoronConcentration] = useState<string | null>(sample.body?.icp_oes_boron_concentration_ppm);
  const [editId, setEditId] = useState<string | null>();
  const [focused, setFocused] = useState<boolean>(false);
  const [enableButton, setEnableButton] = useState<boolean>(true);

  const getISOTime = useCallback(() => {
    const [sampleDay, sampleMonth, sampleYear] = convertDate(sample.body.draw_date_time_utc).split('-');
    const [sampleHour, sampleMinutes, sampleSeconds] = convertTime(sample.body.draw_date_time_utc).split(':');

    const year = tempDrawDate ? tempDrawDate.get('year') : sampleYear;
    const month = tempDrawDate ? tempDrawDate.get('month') : 'JanFebMarAprMayJunJulAugSepOctNovDec'.indexOf(sampleMonth) / 3;
    const days = tempDrawDate ? tempDrawDate.get('date') : sampleDay;
    const hours = tempDrawTime ? tempDrawTime.slice(0, 2) : sampleHour;
    const minutes = tempDrawTime ? tempDrawTime.slice(3, 5) : sampleMinutes;
    const seconds = tempDrawTime ? tempDrawTime.slice(6) : sampleSeconds;

    const time = new Date(year, month, days, hours, minutes, seconds);
    let timeISO;
    try {
      timeISO = time.toISOString();
    } catch (e) {
      timeISO = 'ERROR';
    }

    return timeISO;
  }, [tempDrawDate, tempDrawTime, sample.body.draw_date_time_utc]);

  useEffect(() => {
    if (tempDrawTime && (tempDrawTime.length !== 8 || tempDrawTime.split(':').length !== 3)) return setEnableButton(false);
    setEnableButton(validTime(getISOTime()));
  }, [tempDrawDate, tempDrawTime, getISOTime]);

  const validTime = (timeToCheck: string) => {
    const unixTimeToCheck = new Date(timeToCheck).getTime();

    const currentUnixTime = new Date().getTime();

    return unixTimeToCheck < currentUnixTime ? true : false;
  };

  const dayAdjustment = new Date().getUTCHours() - new Date().getHours() + 1;

  return (
    <Row index={index} key={sample._id} style={{ paddingRight: '24px' }} classes={'sample-history-row-container'}>
      <Cell>
        {status === 'Editing' ? (
          <TextInput value={editId || sampleId} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEditId(e.target.value)} />
        ) : (
          sampleId || 'N/A'
        )}
      </Cell>
      <Cell style={{ textIndent: '5em' }}>{bloodBoronConcentration || 'N/A'}</Cell>
      <Cell>
        {status === 'Editing' ? (
          <SingleDatePicker
            placeholder={drawDate}
            date={tempDrawDate}
            onDateChange={(tempDrawDate: Moment | null) => {
              setTempDrawDate(tempDrawDate);
              setFocused(!focused);
            }}
            appendToBody={true}
            focused={focused}
            onFocusChange={() => setFocused(!focused)}
            id="singleDatePicker"
            numberOfMonths={1}
            displayFormat="dd-MMM-yyyy"
            isOutsideRange={(day: Moment) => day.isAfter(moment().add(dayAdjustment, 'hours'))}
            noBorder
            small
          />
        ) : (
          drawDate
        )}
      </Cell>
      <Cell>
        {status === 'Editing' ? (
          <TextInput
            value={tempDrawTime || drawTime}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTempDrawTime(e.target.value)}
            width={95}
            borderColor={!enableButton ? warning : ''}
          />
        ) : (
          drawTime
        )}
      </Cell>

      <Cell>{sample.header.user.name ?? 'N/A'}</Cell>
      {/* <Cell>
        <FlexContainer justifyContent="center">
          <>
            {edit && (
              <div className="actionButtons">
                <div className="cancel-button-container">
                  <Button
                    icon={<XClose fill={primaryBlue400} />}
                    onClick={() => {
                      setEdit(false);
                      setStatus('');
                    }}
                    width={'40px'}
                    height={'40px'}
                    className={clsx('square-icon-button', 'cancel-button')}
                  ></Button>
                </div>
                <Button
                  icon={<Check fill={neutral50} />}
                  onClick={() => {
                    setEdit(false);
                    handleBloodSampleUpdate();
                  }}
                  width={'40px'}
                  height={'40px'}
                  className={clsx('square-icon-button', 'save-button')}
                  background-color={!enableButton ? neutral300 : null}
                  disabled={!enableButton}
                ></Button>
              </div>
            )}
          </>
          <div>
            {status === 'Uploading Data' ? (
              <LoadingSpinner width={smallSpinner} height={smallSpinner} />
            ) : (
              !edit &&
              !onCloud && (
                <Button
                  icon={<Pencil fill={primaryBlue400} />}
                  onClick={() => {
                    setEdit(true);
                    setStatus('Editing');
                  }}
                  width={'40px'}
                  height={'40px'}
                  className={clsx('square-icon-button', 'edit-button-enabled')}
                ></Button>
              )
            )}
          </div>
        </FlexContainer>
      </Cell> */}
    </Row>
  );
};
